<template>
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Anular venta</h5>
          <button type="button" class="btn-close" aria-label="Close" @click="cerrar" :disabled="enviando"></button>
        </div>
        <div class="modal-body">
          <p v-if="nombreCliente || monto">
            {{ nombreCliente || 'Cliente' }}<template v-if="monto"> — Gs. {{ montoFormateado }}</template>
          </p>

          <div class="mb-3">
            <label class="form-label">Motivo de la anulación</label>
            <textarea
              class="form-control"
              rows="3"
              v-model="motivo"
              :disabled="enviando"
              placeholder="Ej: Cliente solicitó anulación de la compra"
              maxlength="150"
            ></textarea>
          </div>

          <p class="small text-muted mb-0">
            La factura se resuelve ante la SET (cancelación dentro de las 24 horas, nota de crédito después),
            la mercadería vuelve al mostrador y el saldo vuelve al cliente. Si algo impide terminar, no se anula nada.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="cerrar" :disabled="enviando">Cancelar</button>
          <button type="button" class="btn btn-danger" :disabled="!puedeConfirmar || enviando" @click="confirmar">
            <span v-if="enviando" class="spinner-border spinner-border-sm me-1"></span>
            Confirmar anulación
          </button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: 'AnulacionVentaModal',
  props: {
    nombreCliente: { type: String, default: '' },
    monto: { type: Number, default: 0 },
    enviando: { type: Boolean, default: false }
  },
  emits: ['cerrado', 'confirmada'],
  data() {
    return {
      motivo: ''
    }
  },
  computed: {
    montoFormateado() {
      return Number(this.monto || 0).toLocaleString('es-PY')
    },
    puedeConfirmar() {
      // SPEC_ANULACION_FACTURAS_Y_NOTAS_CREDITO_v0.2.md RN-AN44: 5 a 150.
      const largo = this.motivo.trim().length
      return largo >= 5 && largo <= 150
    }
  },
  methods: {
    cerrar() {
      this.$emit('cerrado')
    },
    confirmar() {
      if (!this.puedeConfirmar) return
      this.$emit('confirmada', {
        motivo: this.motivo.trim(),
        // D-AN3: la mercadería vuelve siempre. El campo se sigue mandando
        // porque el API lo acepta durante una versión (y lo ignora).
        devolvio_mercaderia: true
      })
    }
  }
}
</script>
